/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { css } from 'styled-components';
import { colors } from '../colors';
import fonts, { fontSizes } from '../fonts';
import { lineHeights } from '../spacing';

export const linkCss = css`
  color: ${colors.brandPurple};
  cursor: pointer;
  font: ${fonts.bold(fontSizes.h6)};
  text-decoration: none;
  line-height: ${lineHeights.h5};

  &:hover {
    text-decoration: underline;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    text-decoration: underline;
    box-decoration-break: clone;
  }
`;
